import React, { useState } from 'react';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import step1Img from '../../../../assets/images/tour/Welcome_to_taletree.svg';
import step2Img from '../../../../assets/images/tour/change_tribe.svg';
import step3Img from '../../../../assets/images/tour/change_captain.svg';
import step4Img from '../../../../assets/images/tour/add_guardian.svg';
import step5Img from '../../../../assets/images/tour/Tribe_activities.svg';
import eventImg from '../../../../assets/images/tour/events_dropdown.svg';
import lastImg from '../../../../assets/images/tour/last_step.svg';
import './customTourStyles.css'; // You'll define custom styles here
import { useAuth } from '../../../auth/Auth';
import { useMediaQuery, useTheme } from '@mui/material';
import { useRecoilState } from 'recoil';
import {
  currentStepsAtom,
  stepsEnabledAtom,
} from '../../../../atoms/camp.atom';

const CampTour = () => {
  const [currentStep, setCurrentStep] = useRecoilState(currentStepsAtom); // Track the current step
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const { school } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const steps = [
    {
      element: '#step-one',
      intro: `
        <div class="custom-tour-step">
          <img src="${step1Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Welcome to TaleTree, Camp Master!</h3>
          <p>
          ${
            school?.subcription_type === 'premium'
              ? 'You are on the Premium Plan giving you full access to TaleTree village.'
              : 'You are on the Basic Plan, giving you access to the essential features of TaleTree Village.'
          }
            </p>
          <p>You're now the guiding force behind multiple tribes, helping captains and guardians lead children on their creative journeys.</p>
          <p>Let's walk through your core functions:</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
    {
      element: '#step-two',
      intro: `
        <div class="custom-tour-step">
          <img src="${step2Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Oversee All Tribes</h3>
          <p>As a Camp Master, you have access to all tribes in your camp.</p>
          <p>Select “Tribes” from the dropdown menu to create, view and edit tribes, assign captains and invite guardians. View all tribe members progress in real-time and their insights by selecting a tribe from the tab below!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#step-three',
      intro: `
        <div class="custom-tour-step">
          <img src="${step3Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Manage Captains</h3>
          <p>You can assign, remove, or reassign Camp Captains to specific tribes.</p>
          <p>Select the "Captains" from the dropdown menu on your dashboard to ensure each tribe has the right leadership.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#step-four',
      intro: `
        <div class="custom-tour-step">
          <img src="${step4Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Invite Guardians</h3>
          <p>Want to bring more parents into the TaleTree experience? Send out invitations using the "Invite Guardians" feature.</p>
          <p>Guardians will then be able to activate their account depending on the permissions and payment arrangement agreed between yourself and TaleTree.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#step-five',
      intro: `
        <div class="custom-tour-step">
          <img src="${step5Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Monitor Tribe Activities</h3>
          <p>Keep track of all the creative and dream events across your camp.</p>
          <p>Select a tribe from the dropdown menu in your calendar.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#step-tribe-events',
      intro: `
        <div class="custom-tour-step">
          <img src="${step5Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Monitor Tribe Events</h3>
          <p>Then click "View Events” and from there you can access a real-time feed of updates and interactions across the tribe.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#step-six',
      intro: `
        <div class="custom-tour-step">
          <img src="${eventImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Quick tooltips</h3>
          <p>Hover over the question marks next to each feature for quick tooltips, providing guidance whenever you need it.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#last-step',
      intro: `
        <div class="custom-tour-step">
          <img src="${lastImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Lead your camp!</h3>
          <p>You’re now fully equipped to lead your camp! Let’s create something special together at TaleTree.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
  ];

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex); // Track current step
  };

  return (
    <Steps
      enabled={stepsEnabled}
      steps={steps}
      initialStep={0}
      onExit={() => setStepsEnabled(false)} // Handle exit to disable tour
      onChange={handleStepChange} // Track the current step
      options={{
        doneLabel: 'Close',
      }}
    />
  );
};

export default CampTour;
